import {injectable, inject} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IHttpClientService, IApiResponse} from "data/services/http";
import {AxiosResponse} from "axios";

import {IRosterItem} from "data/types/roster";

export interface IRosterProvider {
	getRoster: (contestId: number) => Promise<AxiosResponse<IApiResponse<{roster: IRosterItem}>>>;
	getUserRoster: (
		contestId: number,
		userId: number
	) => Promise<AxiosResponse<IApiResponse<{roster: IRosterItem}>>>;
	saveSpin: (contestId: number) => Promise<AxiosResponse<IApiResponse<{roster: IRosterItem}>>>;
	addPlayer: (
		contestId: number
	) => Promise<AxiosResponse<IApiResponse<{roster: IRosterItem}>, unknown>>;
	playedContests: () => Promise<AxiosResponse<IApiResponse<{contestIds: number[]}>>>;
}

@injectable()
export class RosterProvider implements IRosterProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	getRoster = (contestId: number) =>
		this._http.get<IApiResponse<{roster: IRosterItem}>>(`roster/${contestId}`);
	getUserRoster = (contestId: number, userId: number) =>
		this._http.get<IApiResponse<{roster: IRosterItem}>>(`roster/${contestId}/${userId}`);

	saveSpin = (contestId: number) =>
		this._http.post<IApiResponse<{roster: IRosterItem}>>(`roster/${contestId}/spin`);
	addPlayer = (contestId: number) =>
		this._http.post<IApiResponse<{roster: IRosterItem}>>(`roster/${contestId}/player`);
	playedContests = () =>
		this._http.get<IApiResponse<{contestIds: number[]}>>(`roster/played-contests`);
}
